import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import LoadingSpinner from "../LoadingSpinner";

const DURATION_OPTIONS = [
  { value: "7", label: "7 days" },
  { value: "30", label: "30 days" },
  { value: "90", label: "90 days" },
  { value: "365", label: "1 year" },
  { value: "custom", label: "Custom" },
];

export default function GrantSubscriptionDialog({
  open,
  onClose,
  handleGrantSubscriptionSubmit,
  handleGrantSubscriptionSubmission,
  grantSubscriptionRegister,
  setGrantSubscriptionValue,
  grantDurationOption,
  grantSubscriptionErrors,
  isGrantingSubscription,
  resetGrantSubscription,
}) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity"
      />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="max-w-lg space-y-4 border bg-white rounded-lg">
          <div className="p-8">
            <DialogTitle className="text-xl uppercase pb-4">
              Grant Free Subscription
            </DialogTitle>
            <form
              onSubmit={handleGrantSubscriptionSubmit(
                handleGrantSubscriptionSubmission,
              )}
            >
              <div className="flex flex-wrap -mx-3">
                <div className="w-full px-3 mb-4">
                  <label className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2">
                    Duration
                  </label>
                  <div className="flex flex-col gap-2">
                    {DURATION_OPTIONS.map((option) => (
                      <label
                        key={option.value}
                        className="flex items-center gap-2 text-sm text-gray-900"
                      >
                        <input
                          type="radio"
                          value={option.value}
                          checked={grantDurationOption === option.value}
                          onChange={() =>
                            setGrantSubscriptionValue(
                              "durationOption",
                              option.value,
                              { shouldValidate: true },
                            )
                          }
                          className="h-4 w-4"
                        />
                        {option.label}
                      </label>
                    ))}
                  </div>
                </div>
                {grantDurationOption === "custom" && (
                  <div className="w-full px-3">
                    <label
                      className="block uppercase tracking-wide text-gray-500 text-xs font-bold mb-2"
                      htmlFor="customDays"
                    >
                      Number of days
                    </label>
                    <input
                      id="customDays"
                      type="number"
                      min={1}
                      step={1}
                      {...grantSubscriptionRegister("customDays", {
                        shouldUnregister: true,
                        validate: (value) => {
                          if (grantDurationOption !== "custom") return true;
                          const days = Number(value);
                          return (
                            (Number.isInteger(days) && days > 0) ||
                            "Enter a whole number of days greater than 0"
                          );
                        },
                      })}
                      placeholder="Number of days..."
                      className="appearance-none block w-full text-gray-900 border border-gray-300 rounded p-3 mb-1 leading-tight focus:outline-none focus:bg-white"
                    />
                    {grantSubscriptionErrors?.customDays && (
                      <p className="text-red-500 text-xs mt-1 mb-3">
                        {grantSubscriptionErrors.customDays.message}
                      </p>
                    )}
                  </div>
                )}
              </div>
              <div className="form-field mt-4">
                {isGrantingSubscription && <LoadingSpinner />}
              </div>
              <div className="flex gap-4 bg-gray-50 sm:flex sm:flex-row-reverse p-4">
                <button
                  type="submit"
                  disabled={isGrantingSubscription}
                  className="bg-red-500 text-white p-3 px-10 rounded-md uppercase text-sm hover:bg-red-700 ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isGrantingSubscription ? "Granting..." : "Grant"}
                </button>
                <button
                  type="reset"
                  disabled={isGrantingSubscription}
                  onClick={() => {
                    resetGrantSubscription({
                      durationOption: "7",
                      customDays: "",
                    });
                    onClose();
                  }}
                  className="text-gray-600 font-semibold hover:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
